import React from 'react';
import { Chip } from '@mui/material';
import { Text, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from "../../services/helpers";

import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

import UsageBlock from './UsageBlock';

/**
 * @param usage
 * @param coverage
 * @param fillColor
 * @param waivedDental
 * @returns {JSX.Element}
 * @constructor
 */
const DentalUsageBlock = ({ usage, coverage, fillColor, waivedDental }) => {
    const isCombined = usage.isCombinedMaximum;

    /**
    *
    * @returns
    */
    const calculateCombinedDentalTotals = () => {
        let total = 0;

        usage.used.map((item) => {
            if (item.type === 'Basic Service (Endodontics, Periodontics, Routine Care (Visit and Treatment), Basic Oral Surgery)' ||
                item.type === 'Major Services (Bridge Work, Crowns, Denture Repair, Dentures, Major Oral Surgery)'
            ) {
                total += item.used;
            }

            return null;
        });

        return total;
    };

    return (
        <React.Fragment>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
                <div>
                    <Text
                        medium
                        bold
                        customStyle={{
                            flex: 1,
                            display: 'inline',
                            margin: '0 0 10px 0'
                        }}
                    >
                        { i18n.t(tokens.titles.dental) }
                    </Text>
                    {
                        waivedDental &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "5px 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </div>

                {
                    isCombined &&
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Tooltip 
                                    title={ i18n.t(
                                        tokens.labels.coverage.spendUpToCombinedmaxOnDentalServices,
                                        { combinedMax: numberWithCommas((usage.combinedMax - calculateCombinedDentalTotals()).toFixed(2)) }
                                    )}
                                    arrow 
                                    placement="top"
                                >
                                    <InfoIcon aria-label="info" style={{ fontSize: 15, color: Theme.colors.mediumGrey, marginRight: 10 }} />
                                </Tooltip>

                                <Text small bold>
                                    { i18n.t(tokens.labels.coverage.basicAndMajorCombinedMaximumUsage, { usage: numberWithCommas(usage.combinedMax.toFixed(2)) })}
                                </Text>
                            </div>

                            <Text small bold margin="0 0 10px 0" align="right">
                                { i18n.t(tokens.labels.amountRemaining, { amount: numberWithCommas((usage.combinedMax - calculateCombinedDentalTotals()).toFixed(2)) }) }
                            </Text>
                        </div>
                }
            </div>

            {
                isCombined ?
                    <React.Fragment>
                        {
                            usage.used.map((item) => {
                                if (item.type === 'Basic Service (Endodontics, Periodontics, Routine Care (Visit and Treatment), Basic Oral Surgery)' ||
                                    item.type === 'Major Services (Bridge Work, Crowns, Denture Repair, Dentures, Major Oral Surgery)'
                                ) {
                                    return (
                                        <UsageBlock
                                            key={ item.type }
                                            usage={{
                                                type: item.type,
                                                limit: coverage[item.coverageColumn],
                                                used: item.used
                                            }}
                                            fillColor={ fillColor }
                                        />
                                    );
                                }

                                return null;
                            })
                        }
                        {
                            usage.used.map((item) => {
                                if (item.type !== 'Basic Service (Endodontics, Periodontics, Routine Care (Visit and Treatment), Basic Oral Surgery)' &&
                                    item.type !== 'Major Services (Bridge Work, Crowns, Denture Repair, Dentures, Major Oral Surgery)'
                                ) {
                                    return (
                                        <UsageBlock
                                            key={ item.type }
                                            usage={{
                                                type: item.type,
                                                limit: coverage[item.coverageColumn],
                                                used: item.used
                                            }}
                                            fillColor={ fillColor }
                                            showRemaining={ true }
                                        />
                                    );
                                }

                                return null;
                            })
                        }
                    </React.Fragment>
                    :
                    usage.used.map((item) => (
                        <UsageBlock
                            key={ item.type }
                            usage={{
                                type: item.type,
                                limit: coverage[item.coverageColumn],
                                used: item.used
                            }}
                            fillColor={ fillColor }
                            showRemaining={ true }
                        />
                    ))
            }

            {
                usage.unused.map((item) => (
                    <UsageBlock
                        key={ item.type }
                        usage={{
                            type: item.type,
                            limit: coverage[item.coverageColumn],
                            used: item.used
                        }}
                        fillColor={ fillColor }
                    />
                ))
            }
        </React.Fragment>
    );
};

export default DentalUsageBlock;